<div class="flex zen-main-container">
    <div class="m-auto text-center">
        <h1 class="text-8xl	text-zen p-5">THANK YOU!</h1>
        <i class="fa fa-check text-8xl	text-exp border-4 border-exp rounded-full p-8" ></i>
    </div>
  </div>
  <z-footer></z-footer>